import React, { useCallback } from 'react';
import Showreel from './Showreel/Showreel';
import Stars from './Stars/Stars';
import Services from './Preview/Services';
import Work from './Work/Work';
import Clients from './Clients/Clients';

function IndexPage({starsRef, scrollToStars, videosRef, scrollToVideos }) {
  return (
    <>
      <Showreel scrollToStars={scrollToStars} />
      <Stars ref={starsRef} scrollToVideos={scrollToVideos} />
      <Services />
      <Work ref={videosRef} />
      <Clients />
    </>
  );
}

export default IndexPage;
